import { writable } from "svelte/store";
import type { AuthUser } from "./api";

// null = not logged in (or not yet checked).
export const currentUser = writable<AuthUser | null>(null);
